var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseStroke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7785_70653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.636 5.864C10.3245 5.55251 9.81949 5.55251 9.508 5.864L8 7.372L6.492 5.864C6.18051 5.55251 5.67549 5.55251 5.364 5.864C5.05251 6.17549 5.05251 6.68051 5.364 6.992L6.872 8.5L5.364 10.008C5.05251 10.3195 5.05251 10.8245 5.364 11.136C5.67549 11.4475 6.18051 11.4475 6.492 11.136L8 9.628L9.508 11.136C9.81949 11.4475 10.3245 11.4475 10.636 11.136C10.9475 10.8245 10.9475 10.3195 10.636 10.008L9.128 8.5L10.636 6.992C10.9475 6.68051 10.9475 6.17549 10.636 5.864ZM8 0.5C3.576 0.5 0 4.076 0 8.5C0 12.924 3.576 16.5 8 16.5C12.424 16.5 16 12.924 16 8.5C16 4.076 12.424 0.5 8 0.5ZM8 14.9C4.472 14.9 1.6 12.028 1.6 8.5C1.6 4.972 4.472 2.1 8 2.1C11.528 2.1 14.4 4.972 14.4 8.5C14.4 12.028 11.528 14.9 8 14.9Z",
    fill: "#333333",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7785_70653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseStroke);
export default __webpack_public_path__ + "static/media/close_stroke.50fe09b281db865890f8a949c9f47145.svg";
export { ForwardRef as ReactComponent };